<router-outlet></router-outlet>
<ng-snotify class="material"></ng-snotify>

